
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { fadeInVariants, slideInVariants } from '@/lib/animations';

const WorkPerformanceSummaryCards = () => {
  return (
    <motion.div 
      className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8"
      variants={slideInVariants.up}
      initial="initial"
      animate="animate"
      transition={{ staggerChildren: 0.1 }}
    >
      <motion.div variants={fadeInVariants}>
        <Card className="overflow-hidden">
          <CardHeader className="pb-2 bg-gradient-to-r from-blue-50 to-white">
            <CardTitle className="text-xl">Produtividade</CardTitle>
            <CardDescription>Média semanal</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-3xl font-bold text-brand-blue">67.4%</div>
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-4 h-4 mr-1 rounded-full bg-green-500 text-white text-xs flex items-center justify-center">+</span>
              2.3% da semana anterior
            </p>
          </CardContent>
        </Card>
      </motion.div>
      
      <motion.div variants={fadeInVariants}>
        <Card className="overflow-hidden">
          <CardHeader className="pb-2 bg-gradient-to-r from-purple-50 to-white">
            <CardTitle className="text-xl">Foco</CardTitle>
            <CardDescription>Média semanal</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-3xl font-bold text-purple-500">66.6%</div>
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-4 h-4 mr-1 rounded-full bg-red-500 text-white text-xs flex items-center justify-center">-</span>
              1.2% da semana anterior
            </p>
          </CardContent>
        </Card>
      </motion.div>
      
      <motion.div variants={fadeInVariants}>
        <Card className="overflow-hidden">
          <CardHeader className="pb-2 bg-gradient-to-r from-green-50 to-white">
            <CardTitle className="text-xl">Satisfação</CardTitle>
            <CardDescription>Média semanal</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-3xl font-bold text-green-500">62.8%</div>
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-4 h-4 mr-1 rounded-full bg-green-500 text-white text-xs flex items-center justify-center">+</span>
              3.5% da semana anterior
            </p>
          </CardContent>
        </Card>
      </motion.div>
      
      <motion.div variants={fadeInVariants}>
        <Card className="overflow-hidden">
          <CardHeader className="pb-2 bg-gradient-to-r from-yellow-50 to-white">
            <CardTitle className="text-xl">Eficiência</CardTitle>
            <CardDescription>Média semanal</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-3xl font-bold text-yellow-500">69.0%</div>
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-4 h-4 mr-1 rounded-full bg-green-500 text-white text-xs flex items-center justify-center">+</span>
              1.8% da semana anterior
            </p>
          </CardContent>
        </Card>
      </motion.div>
    </motion.div>
  );
};

export default WorkPerformanceSummaryCards;
